import {
  toAppliedFilterChips,
  withoutFilterValue,
} from "ui/data-grid/components/applied-filters/applied-filters.helpers";
import type { AppliedFiltersState } from "ui/data-grid/components/applied-filters/applied-filters.types";

import type { FiltersToApply } from "types/filters";

/** Partial because a table without filters calls it too, with no state at all — and gets no chips. */
type UseAppliedFiltersParams<TFilters extends FiltersToApply> = Partial<AppliedFiltersState<TFilters>>;

export const useAppliedFilters = <TFilters extends FiltersToApply>({
  filtersToApply,
  setFiltersToApply,
  defaultFiltersToApply,
  filterIdToTitle = {},
  filterValueToLabel,
}: UseAppliedFiltersParams<TFilters>) => {
  const items = filtersToApply
    ? toAppliedFilterChips(filtersToApply, filterIdToTitle, filterValueToLabel)
    : [];

  const handleRemove = (id: string) => {
    const chip = items.find((item) => item.id === id);

    if (!chip || !filtersToApply) {
      return;
    }

    setFiltersToApply?.(withoutFilterValue(filtersToApply, chip.filterId, chip.value));
  };

  const handleClearAll = () => {
    if (defaultFiltersToApply) {
      setFiltersToApply?.(defaultFiltersToApply);
    }
  };

  return { items, handleRemove, handleClearAll };
};
